import { render, staticRenderFns } from "./mortgage-taxes.vue?vue&type=template&id=70c31d62"
import script from "./mortgage-taxes.vue?vue&type=script&lang=js"
export * from "./mortgage-taxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports